import { render, staticRenderFns } from "./PartnerReport.vue?vue&type=template&id=b62cc820"
import script from "./PartnerReport.vue?vue&type=script&lang=js"
export * from "./PartnerReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports